import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const StarFilledIcon: React.FC<OneColorIconProps> = ({ size = 24, color = 'black', className }) => {
  return (
    <svg
      data-testid="star-filled-icon"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18.7552L7.15274 21.8127C6.9386 21.9554 6.71473 22.0166 6.48113 21.9962C6.24753 21.9758 6.04313 21.8943 5.86792 21.7516C5.69272 21.6089 5.55645 21.4305 5.45912 21.2165C5.36178 21.0025 5.34232 20.763 5.40072 20.498L6.68553 14.7193L2.39308 10.8362C2.19841 10.6528 2.07674 10.4439 2.02808 10.2094C1.97941 9.97503 1.99401 9.74572 2.07188 9.5215C2.14975 9.29728 2.26655 9.11383 2.42228 8.97114C2.57802 8.82846 2.79215 8.73674 3.06469 8.69597L8.72956 8.17619L10.9196 2.7338C11.0169 2.4892 11.1678 2.30575 11.3722 2.18345C11.5766 2.06115 11.7859 2 12 2C12.2141 2 12.4234 2.06115 12.6278 2.18345C12.8322 2.30575 12.9831 2.4892 13.0804 2.7338L15.2704 8.17619L20.9353 8.69597C21.2078 8.73674 21.422 8.82846 21.5777 8.97114C21.7335 9.11383 21.8503 9.29728 21.9281 9.5215C22.006 9.74572 22.0206 9.97503 21.9719 10.2094C21.9233 10.4439 21.8016 10.6528 21.6069 10.8362L17.3145 14.7193L18.5993 20.498C18.6577 20.763 18.6382 21.0025 18.5409 21.2165C18.4435 21.4305 18.3073 21.6089 18.1321 21.7516C17.9569 21.8943 17.7525 21.9758 17.5189 21.9962C17.2853 22.0166 17.0614 21.9554 16.8473 21.8127L12 18.7552Z"
        fill={getHexColor(color)}
      />
    </svg>
  )
}
